import axios from "axios";

// Set up a base URL for all API calls
export const API_BASE_URL = "https://smartsathi.in/backend/";
// const API_BASE_URL = "http://localhost:2083/backend/";

// Create an instance of axios with default settings
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // 10 seconds timeout
});

